module.exports = __webpack_public_path__ + "img/Luna.07e678a6.07e678a6.png";